import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from 'styleguide/Buttons';
import { colors } from 'styleguide/colors';
import { Modal, ModalTitle, zIndex } from 'styleguide/Modal';
import { Spacing } from 'styleguide/spacing';
import { P2 } from 'styleguide/Texts';
import { View } from 'styleguide/View';

const Container = styled(View)`
  overflow: hidden;
  gap: ${Spacing.md}px;
`;

const UpperContainer = styled(View)`
  align-items: flex-start;
  gap: ${Spacing.md}px;
`;

const LowerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: ${Spacing.md}px;
`;

export interface AlertModalProps {
  title: string;
  body?: string;
  confirmButtonStyle?: 'primary' | 'destructive';
  confirmButtonTitle: string;
  cancelButtonTitle?: string;
  isOpen: boolean;
  onClose?: (confirm: boolean) => void;
}

export const AlertModal = ({
  title,
  body,
  confirmButtonStyle,
  confirmButtonTitle,
  cancelButtonTitle,
  isOpen,
  onClose,
}: AlertModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose?.(false)}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      overlayStyle={{ zIndex: zIndex.modalOverlay }}
      contentStyle={{ padding: Spacing.lg }}
    >
      <Container>
        <UpperContainer>
          <ModalTitle title={title} onClose={() => onClose?.(false)} />
          {body && <P2 type="secondary">{body}</P2>}
        </UpperContainer>
        <LowerContainer>
          {cancelButtonTitle && (
            <SecondaryButton title={cancelButtonTitle} onClick={() => onClose?.(false)} />
          )}
          <PrimaryButton
            style={confirmButtonStyle === 'destructive' ? styles.destructiveButton : undefined}
            title={confirmButtonTitle}
            onClick={() => onClose?.(true)}
          />
        </LowerContainer>
      </Container>
    </Modal>
  );
};

const styles: { [key: string]: CSSProperties } = {
  destructiveButton: {
    backgroundColor: colors.red,
  },
};
